import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FlurryAnalytics, FlurryAnalyticsObject, FlurryAnalyticsOptions } from '@ionic-native/flurry-analytics';
import { AppSettings } from '../../app/app.settings';

/*
  Generated class for the FlurryProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FlurryProvider {
  public fa: FlurryAnalyticsObject;

  private static FLURRY_API_KEY = AppSettings.FLURRY.apiKey;

  constructor(
    private flurryAnalytics: FlurryAnalytics,
    private platform: Platform) {

    const options: FlurryAnalyticsOptions = {
      appKey: FlurryProvider.FLURRY_API_KEY,
      reportSessionsOnClose: true,
      enableLogging: true
    };

    this.fa = this.flurryAnalytics.create(options);
  }

  flurryAnalyticsInit() {
    const options: FlurryAnalyticsOptions = {
      appKey: FlurryProvider.FLURRY_API_KEY,
      reportSessionsOnClose: true,
      enableLogging: true
    };

    this.fa = this.flurryAnalytics.create(options);
  }

  faLogEvent(event: string) {
    if (this.platform.is('cordova')) {

      const options: FlurryAnalyticsOptions = {
        appKey: FlurryProvider.FLURRY_API_KEY,
        reportSessionsOnClose: true,
        enableLogging: true
      };

      let trigger = this.flurryAnalytics.create(options);

      return trigger.logEvent(event)
        .then(() => console.log('Logged an event!', event))
        .catch(e => console.log('Error logging the event', e));
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/flurry/flurry.ts